// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c6769778","453":"e52fcbdc","644":"5b50be9d","732":"16c9f882"}[chunkId] + ".chunk.js";
};